import { render, staticRenderFns } from "./Kassa.vue?vue&type=template&id=6efb7484&scoped=true"
import script from "./Kassa.vue?vue&type=script&lang=js"
export * from "./Kassa.vue?vue&type=script&lang=js"
import style0 from "./Kassa.vue?vue&type=style&index=0&id=6efb7484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb7484",
  null
  
)

export default component.exports